<template>
  <v-dialog v-model="show" persistent max-width="450">
    <v-card>
      <v-card-title>Mark Ontario Spirits Return as filed</v-card-title>
      <v-divider/>

      <v-container>
        <v-row>
          <v-col cols="7" class="text-right">File for period end:</v-col>
          <v-col class="font-weight-bold">{{periodEnd | formatDate}}</v-col>
        </v-row>
        <v-row v-if="thisPeriod" class="warning--text">
          <v-col>Cannot file MOF reports for the current period until the period ends.</v-col>
        </v-row>
        <template v-else>
          <v-row>
            <v-col cols="7" class="text-right">Due:</v-col>
            <v-col class="font-weight-bold">{{dueDate | formatDate}}</v-col>
          </v-row>
          <v-row>
            <v-col cols="7" class="text-right">
              Payment amount:
            </v-col>
            <v-col class="font-weight-bold">{{mainReturn[22] | currency}}</v-col>
          </v-row>

          <v-row v-if="mainReturn[22] && createReceipt">
            <v-col class="mx-1">
              An inventory receipt will be created for the taxes payable.
            </v-col>
          </v-row>
          <v-row>
            <v-col class="warning--text mx-1">
              This will mark your Ontario Spirit Return as filed for this period.
              No further transactions affecting product sales will be allowed in this period.
            </v-col>
          </v-row>
        </template>
      </v-container>

      <v-divider/>
      <v-card-actions class="px-6">
        <v-spacer></v-spacer>
        <v-btn plain color="primary" @click="cancel">Cancel</v-btn>
        <v-btn color="primary" @click="save" :loading="saving" :disabled="thisPeriod">File</v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>
import {add,format,lastDayOfMonth} from 'date-fns';

export default {
  name: 'ReportsOntarioSpiritsFile',
  props: {
    value: {type:Boolean, required:true}
  },
  data() {
    return {
      show: this.value,
      saving: false,
      thisPeriod: false,
      periodEnd: null,
      dueDate: null,
      mainReturn: {},
      createReceipt: false
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    }
  },
  watch: {
    value() {
      this.show = this.value;
      if (this.show)
        this.init();
    },
  },
  methods: {
    async init() {
      let results = await this.$apiCall(`query ReportsOntarioSpiritsFile {
                                            ontarioPreferences {
                                              mofPeriodEnd,createReceipt
                                            }
                                           }`,
                                          {});
      if (results.error)
        return;

      this.createReceipt = results.data.ontarioPreferences.createReceipt;
      const mofPeriodEnd = results.data.ontarioPreferences.mofPeriodEnd;
      const date = lastDayOfMonth(mofPeriodEnd !== '1999-12-31' ?
                                  add(new Date(mofPeriodEnd),{days:2}) :  // Next period from last filed
                                  add(new Date(),{months:-1}));                       // end of last month
      this.periodEnd = format(date, 'yyyy-MM-dd');
      this.dueDate = format(add(date, {days:20}),'yyyy-MM-dd');
      this.thisPeriod = this.periodEnd > format(new Date(),'yyyy-MM-dd');
      results = await this.$apiCall(`query ReportsOntarioSpiritsFile($date:Date!) {
                                        ontarioSpiritsReport(date:$date) {
                                          mainReturn
                                        }
                                      }`,
                                    {date:this.periodEnd.substring(0,8)+'01'});
      if (results.error)
        return;
      this.mainReturn = results.data.ontarioSpiritsReport.mainReturn;
    },
    async save() {
      this.saving = true;
      const results = await this.$apiCall(`mutation ReportsOntarioSpiritsFile($periodEnd:Date!, $amount:Float!) {
                                              mofFile(periodEnd:$periodEnd, amount:$amount)
                                            }`,
                                          {periodEnd:this.periodEnd, amount:this.mainReturn[22]});
      this.saving = false;
      if (!results.error) {
        this.$store.commit('setError', {message:'Ontario Spirits Return filed',type:'success'});
        this.$emit('filed', this.periodEnd);
        this.cancel();
      }
    },
    cancel() {
      this.show = false;
      this.$emit('input', false);
    },
  }
}
</script>